import React, { Component } from 'react';
const debounce = require('lodash.debounce');

class FulltextSearch extends Component
{
    componentDidMount() {
        this.refs.fulltextSearch.value = this.props.phrase
    }

    render() {
        return <div className={'form-group'}>
            <label htmlFor="fulltext">{this.props.fulltextLabel}</label>
            <input placeholder={this.props.placeholderText} type={'text'} className={'form-control'} ref={'fulltextSearch'} style={{ width: '100%'}}  onKeyUp={ debounce(()=>this.props.fulltextSubmit(this.refs.fulltextSearch.value), 750) } />
        </div>
    }
}

export default FulltextSearch




// WEBPACK FOOTER //
// ./src/components/FulltextSearch.js